import React, { useState, useEffect } from 'react';
import AuthApi from 'api/AuthApi';
import getCookieByName from 'sources/getCookieByName';

const AuthContext = React.createContext('auth');

export const AuthContextProvider = props => {
  const [login, setLogin] = useState({
    processing: false,
    error: null,
    currentUser: null,
    authorized: false,
  });

  useEffect(() => {
    if (!getCookieByName('access_token')) {
      return;
    }

    AuthApi.loginByToken()
      .then(result => {
        setLogin({
          ...login,
          currentUser: result,
          processing: false,
          authorized: true,
        });
      })
      .catch(err => {
        setLogin({ ...login, err, processing: false });
        throw err;
      });
  }, []);

  async function handleLogin(email, password) {
    try {
      const result = await AuthApi.login(email, password);
      setLogin({
        ...login,
        currentUser: result,
        processing: false,
        authorized: true,
      });
    } catch (error) {
      setLogin({ ...login, error, processing: false });
    }
  }

  async function handleLogout() {
    try {
      await AuthApi.logout();
      setLogin({
        ...login,
        currentUser: null,
        processing: false,
        authorized: false,
      });
    } catch (error) {
      setLogin({ ...login, error, processing: false });
    }
  }

  const { currentUser, error, processing, authorized } = login;

  return (
    <AuthContext.Provider
      value={{
        currentUser,
        error,
        processing,
        authorized,
        onLogin: handleLogin,
        onLogout: handleLogout,
      }}
    >
      {props.children}
    </AuthContext.Provider>
  );
};

export default AuthContext;



// WEBPACK FOOTER //
// ./src/contexts/AuthContext.jsx